import styles from './Header.module.scss'
import cookchef from '../../assets/images/cookchef.png'
import { useState } from 'react'
import HeaderMenu from './components/HeaderMenu/HeaderMenu'

function Header(){

    const [displayMenu, setDisplayMenu] = useState(false)

    return (
    <header className={`${ styles.header } d-flex flex-row align-items-center` }>
        <div className='flex-fill'>
            <img src={ cookchef } alt="logo cookchef" />
        </div>
        <ul className={styles.headerList}>
            <button className='mr-5 btn btn-reverse-primary'>
            <i className="fa-solid fa-heart mr-5"></i>
                <span>Wishlist</span>
            </button>
            <button className='btn btn-primary'>
                Connexion
            </button>
        </ul>
        <i onClick={() => setDisplayMenu(!displayMenu)} className={`fa-solid fa-bars ${styles.headerXs}`}></i>
        {displayMenu && 
            <>
                <div onClick={() => setDisplayMenu(false)} className='calc'></div>
                <HeaderMenu />
            </>
        }
    </header>
    )
}

export default Header